import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import CompareRow from "./compareRow";

const CompareBody = ({ name, free, prem, enter }) => {
  return (
    <>
      <CompareRow
        name={name}
        title={true}
        free={false}
        prem={false}
        enter={false}
      />
      <CompareRow
        name={"ImageWatermark"}
        title={false}
        free={free}
        prem={prem}
        enter={enter}
      />
      <CompareRow
        name={"SignatureWatermark"}
        title={false}
        free={free}
        prem={prem}
        enter={enter}
      />
      <CompareRow
        name={"TextWatermark"}
        title={false}
        free={free}
        prem={prem}
        enter={enter}
      />
      <CompareRow
        name={"StickerWatermark"}
        title={false}
        free={free}
        prem={prem}
        enter={enter}
      />
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td className="border-0"></td>
      </tr>
    </>
  );
};

export default CompareBody;
